import { useCallback } from "react";
import { AuthServices } from "../../features/auth/services/AuthServices";

const useUpdateOnboardingStatus = () => {
  const updateStatus = useCallback(async (keyword) => {
    const onboardingStatus = await AuthServices.updateOnboardingStatus(keyword);
    if (!onboardingStatus.success) {
      console.error(
        `Error updating onboarding "${keyword}" status:`,
        onboardingStatus
      );
      return false;
    }
    return true;
  }, []);

  return updateStatus;
};

export default useUpdateOnboardingStatus;
